import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** AI / legacy placeholders that mean "field not provided" — must not be shown to users. */
const UNKNOWN_FIELD_RE = /^<?\s*unknow(n)?\s*>?$/i;

export function isUnknownJobFieldValue(value: string | undefined | null): boolean {
  if (value == null) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return UNKNOWN_FIELD_RE.test(trimmed);
}

/** Returns undefined when location is empty or an unknown placeholder. */
export function normalizeJobLocation(value: string | undefined | null): string | undefined {
  if (value == null) return undefined;
  const trimmed = value.trim();
  if (!trimmed || isUnknownJobFieldValue(trimmed)) return undefined;
  return trimmed;
}

/** Recruiter UI: show translated "not specified" when missing or placeholder. */
export function formatJobLocationForDisplay(
  value: string | undefined | null,
  notSpecifiedLabel: string,
): string {
  const normalized = normalizeJobLocation(value);
  return normalized ?? notSpecifiedLabel;
}
